var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeVenue)?_c('div',[_c('vs-row',[_c('h3',{staticClass:"mr-4"},[_vm._v("End of Day reports")])]),(_vm.activeTab == 0)?_c('div',{staticClass:"tab-general md:ml-4 md:mt-0 mt-4 ml-0"},[_c('eod-reports-list')],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }